<template lang="pug">
div.flex.flex-col.gap-4(v-if="draft && latestSaved")
  PrettyDiff(v-if="hasYamlChanges" :diff="yamlDiffString" :name="yamlFilename")
  PrettyDiff(v-if="hasCssChanges" :diff="cssDiffString" :name="cssFilename")
</template>

<script setup lang="ts">
import { computed, watchEffect, ref } from 'vue';
import PrettyDiff from './PrettyDiff.vue';
import { createPatch } from 'diff';
import { getLatestSaved } from '../../lib/callModContent';

const props = defineProps<{
  draft: CourseDraft | null;
}>();

const latestSaved = ref<CourseDraft | null>(null);

const yamlFilename = computed(() =>
  props.draft?.firmCode
    ? `${props.draft.firmCode}_${props.draft.courseId}.yml`
    : `${props.draft?.courseId}.yml`
);

const cssFilename = computed(() =>
  props.draft?.firmCode
    ? `${props.draft.firmCode}_${props.draft.courseId}.css`
    : `${props.draft?.courseId}.css`
);

watchEffect(async () => {
  if (props.draft) {
    latestSaved.value = await getLatestSaved({
      courseId: props.draft.courseId,
      firmCode: props.draft.firmCode
    });
  }
});

const yamlDiffString = computed(() => {
  if (!props.draft || !latestSaved.value) return '';
  return createPatch(
    yamlFilename.value,
    latestSaved.value.yaml || '',
    props.draft.yaml || ''
  );
});

const cssDiffString = computed(() => {
  if (!props.draft || !latestSaved.value) return '';
  return createPatch(
    cssFilename.value,
    latestSaved.value.css || '',
    props.draft.css || ''
  );
});

const hasYamlChanges = computed(() => {
  if (!props.draft || !latestSaved.value) return false;
  return props.draft.yaml !== latestSaved.value.yaml;
});

const hasCssChanges = computed(() => {
  if (!props.draft || !latestSaved.value) return false;
  return props.draft.css !== latestSaved.value.css;
});
</script>
